import { useEffect, useState } from "react";
import { AdminService } from "../../../Services/Admin.service";
import { DonorService } from "../../../Services/Donor.Service";
import { Table, Dropdown, DropdownButton, Pagination } from "react-bootstrap";
import { FaSearch } from "react-icons/fa";
import dayjs from 'dayjs';
import navdots from "../../../Assets/images/navdots.svg";
import Toaster from "../../../Components/Toaster";
import { Link, useNavigate } from "react-router-dom";


import TablePagination from "../../../Components/AdministrativeSettings/TablePagination";
import SearchInput from "../../../Components/AdministrativeSettings/SearchInput";
import AdminStatusDropdown from "../../../Components/AdministrativeSettings/AdminStatusDropdown";

import BiologicalSexDropdown from "../../../Components/AdministrativeSettings/BiologicalSexDropdown";
import SampleTypeDropdown from "../../../Components/AdministrativeSettings/SampleTypeDropdown";
import NumberOfDonationSort from "../../../Components/AdministrativeSettings/NumberOfDonartionSort";
import NoListDataAvailable from "../../../Components/NoListDataAvailable";
import LoadingComponent from "../../../Components/LoadingComponent";
import { getLabStatuses, getStatuses, SampleRequestService } from "../../../Services/SampleRequest.Service";
import SampleTypeTableRow from "../../../Components/AdministrativeSettings/SampleRequest/SampleTypeTableRow";
import TokenService from "../../../Services/Token.service";
import DateRangeFilter from "../../../Components/AdministrativeSettings/DateRangeFilter";
import Loader from "../../../Components/Loader";
import { useMediaQuery } from "react-responsive";


function SampleRequestListTable(props) {

    const navigate = useNavigate();

    
    const [loading, setLoading] = useState(true);

    const [showToast, setShowToast] = useState(false);
    const [toastMessage, setToastMessage] = useState('');
    const [toastVariant, setToastVariant] = useState('');

    const [totalSampleRequest, setTotalSampleRequest] = useState(0);
    const [SampleTypeList, setSampleRequestList] = useState([]);


    const [statuses, setStatuses] = useState([]);
    const [labStatuses, setLabStatuses] = useState([]);
    const [samples, setSamples] = useState([]);
    const [genders, setGenders] = useState([]);
    //   const [roles, setRoles] = useState([]);
    const [selectedStatuses, setSelectedStatuses] = useState([]);
    const [selectedLabStatuses, setSelectedLabStatuses] = useState([]);
    const [selectedGenders, setSelectedGenders] = useState([]);
    const [selectedSamples, setSelectedSamples] = useState([]);
    //   const [selectedRoles, setSelectedRoles] = useState([]);


    const [rowsPerPage, setRowsPerPage] = useState(10);
    const [pagination, setPagination] = useState({ page: 1, limit: 10, offset: 0 });

    const [jobName, setJobName] = useState("");
    const [isJobNameVisible, setJobNameInputVisible] = useState(false);


    const [requestorName, setRequestorName] = useState("");
    const [isRequestorNameVisible, setRequestorNameInputVisible] = useState(false);

    const [projectName, setProjectName] = useState("");
    const [isProjectNameVisible, setProjectNameInputVisible] = useState(false);


    const [selectedDateRange, setSelectedDateRange] = useState([null, null]);

    //   const [searchEmail, setSearchEmail] = useState("");
    //   const [isSearchEmailVisible, setSearchEmailVisible] = useState(false);
    //   const [searchPhone, setSearchPhone] = useState("");
    //   const [isSearchPhoneVisible, setSearchPhoneVisible] = useState(false);
    //   const [searchId, setSearchId] = useState("");
    //   const [isSearchIdVisible, setSearchIdVisible] = useState(false);

    const { isClearFilter } = props;
    const { onFilterCountChange } = props;
    const { exportCsv } = props;
    const { selectedRange } = props;
    const { type } = props;
    const {openRequestsFilter} =props;
    const {appointmentsFilter}=props;
    useEffect(() => {
        if (isClearFilter) {
            setSelectedStatuses([]);
            setSelectedLabStatuses([]);
            setSelectedGenders([]);
            setSelectedSamples([]);
            setJobName("");
            setJobNameInputVisible(false);

            setRequestorName("");
            setRequestorNameInputVisible(false);

            setProjectName("");
            setProjectNameInputVisible(false);

            onFilterCountChange(0);
            setSelectedDateRange([null, null]);

        }
    }, [isClearFilter]);

    // useEffect(()=>{    
    //     if(openRequestsFilter || appointmentsFilter){
    //     if(openRequestsFilter?.length ||  (appointmentsFilter[0] && appointmentsFilter[1])){
    //         if(openRequestsFilter?.length){ 
    //             if( type === 'requestor'){debugger
    //                 // setSelectedLabStatuses(openRequestsFilter); 
    //                 setSelectedStatuses(openRequestsFilter);  
    //             }
    //             else{
    //                 debugger
    //                 setSelectedStatuses(openRequestsFilter);  
    //             }
    //         }
    //         else{debugger
    //             if( type === 'requestor'){ 
    //                 setSelectedLabStatuses([]);
    //             }
    //             else{
    //                 setSelectedStatuses([]);  
    //             }
    //         }
    //         // if( type === 'requestor'){ 
    //         //     setSelectedStatuses([]); 
    //         // }
    //         // else{
    //         //     setSelectedLabStatuses([]);
    //         // }

    //         setSelectedGenders([]);
    //         setSelectedSamples([]);
    //         setJobName("");
    //         setJobNameInputVisible(false);

    //         setRequestorName("");
    //         setRequestorNameInputVisible(false);

    //         setProjectName("");
    //         setProjectNameInputVisible(false);

    //         onFilterCountChange(0);
    //         debugger
    //         if (appointmentsFilter[0] && appointmentsFilter[1]) {
    //             setSelectedDateRange(appointmentsFilter);  
    //         }
    //         else{
    //             setSelectedDateRange([null, null]); 
    //         }
    //     }}
    //     // if(openRequestsFilter?.length){
    //     //     setSelectedStatuses(openRequestsFilter);
    //     // }

    //     // if (appointmentsFilter[0] && appointmentsFilter[1]) {
    //     //     setSelectedDateRange(appointmentsFilter);  
    //     // } 
    // },[openRequestsFilter, appointmentsFilter]);

    useEffect(() => {
    // CASE 1: Status filter applied → clear date range
    if (openRequestsFilter?.length) {

        setSelectedStatuses(openRequestsFilter);
        setSelectedDateRange([null, null]);   // ⬅️ remove date filter

    }
    // CASE 2: Date range applied → clear status filter
    else if (appointmentsFilter?.[0] && appointmentsFilter?.[1]) {

        setSelectedStatuses([]);               // ⬅️ remove status filter
        setSelectedDateRange(appointmentsFilter);

    }
    // CASE 3: Nothing applied → clear everything
    else {
        setSelectedStatuses([]);
        setSelectedDateRange([null, null]);
    }

    // Reset dependent filters
    setSelectedGenders([]);
    setSelectedSamples([]);

    setJobName("");
    setJobNameInputVisible(false);

    setRequestorName("");
    setRequestorNameInputVisible(false);

    setProjectName("");
    setProjectNameInputVisible(false);

    onFilterCountChange(0);

    }, [openRequestsFilter, appointmentsFilter]);


 
    // Calculate and update the filter count
    useEffect(() => {
        const count = [
            selectedStatuses.length > 0 ? 1 : 0,
            selectedLabStatuses.length > 0 ? 1 : 0,
            selectedGenders.length > 0 ? 1 : 0,
            selectedSamples.length > 0 ? 1 : 0,
            selectedDateRange[0] && selectedDateRange[0] != null ? 1 : 0,
            jobName ? 1 : 0,
            requestorName ? 1 : 0,
            projectName ? 1 : 0,
        ].reduce((sum, val) => sum + val, 0);

        onFilterCountChange(count);
    }, [selectedStatuses, selectedLabStatuses, selectedGenders, jobName, requestorName, projectName, selectedSamples, selectedDateRange]);

    useEffect(() => {

        if (exportCsv) {

            setLoading(true);
            const userId = TokenService.getUserId();

            const widgetFilter =
            openRequestsFilter.length > 0 || appointmentsFilter[0] || appointmentsFilter[1]  
                ? type === 'requestor'
                    ? [0, 1, 5, 6, 7, 8]
                    : [1, 5, 6, 7, 8]
                : type === 'requestor'?  [] : [1, 4, 5, 6, 7, 8];
    
            // Use widgetFilter if selectedStatuses is empty
            const statusFilter = selectedStatuses.length === 0 ? widgetFilter : selectedStatuses;

            const filters = {
                requestor_name: requestorName,
                // status: selectedStatuses,
                job: jobName,
                status : statusFilter,
                // status: type === 'requestor'
                //     // ? (selectedStatuses.length === 0 ? [0, 2, 3] : selectedStatuses)
                //     // : (selectedStatuses.length === 0 ? [1, 5, 6, 7, 8, 9] : selectedStatuses),

                //     // ? (selectedStatuses.length === 0 ? [0, 1, 2] : selectedStatuses)
                //     ? (selectedStatuses.length === 0 ? [] : selectedStatuses)
                //     : (selectedStatuses.length === 0 ? [1, 4, 5, 6, 7, 8] : selectedStatuses),

                from_date: selectedDateRange[0],
                to_date: selectedDateRange[1],
                project_name: projectName,
                lab_status: selectedLabStatuses,
                lab_name: null
            };

            const params = {
                filters: [filters],
                range: selectedRange,
                user_id: type == 'requestor' ? userId : null,
            };

            SampleRequestService.exportSampleRequestList(params)
                .then((response) => {
                    if (response.success) {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("success");

                        const downloadUrl = response.download_url;
                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        // link.setAttribute('download', 'SampleType_export.csv');
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                        setLoading(false);
                    } else {
                        setShowToast(true);
                        setToastMessage(response.message);
                        setToastVariant("danger");
                        setLoading(false);
                    }
                })
                .catch((error) => {
                    setShowToast(true);
                    setToastMessage("Error exporting SampleType list.");
                    setToastVariant("danger");
                    console.error("Error exporting SampleType list:", error);
                    setLoading(false);
                });
        }
    }, [exportCsv]);


    useEffect(() => {
        fetchStatuses();
        fetchLabStatuses();
        fetchGenders();
        fetchSampleTypes();
    }, []);

    useEffect(() => {
        fetchSampleTypeList();
    }, [pagination, selectedStatuses, selectedLabStatuses, selectedGenders, jobName, requestorName, projectName, selectedSamples, selectedRange, selectedDateRange]);
    //   selectedRoles, searchEmail, searchPhone, searchId

    function fetchSampleTypeList() {
        setLoading(true);

        const userId = TokenService.getUserId();
        //check if widget filter is applied if yes then dont pass 4 is cancelled  else default array is passed.
        const widgetFilter =
        openRequestsFilter.length > 0 || appointmentsFilter[0] || appointmentsFilter[1]  
            ? type === 'requestor'
                ? [0, 1, 5, 6, 7, 8]
                : [1, 5, 6, 7, 8]
            : type === 'requestor'?  [] : [1, 4, 5, 6, 7, 8];

        // Use widgetFilter if selectedStatuses is empty
        const statusFilter = selectedStatuses.length === 0 ? widgetFilter : selectedStatuses;


        const filters = {
            requestor_name: requestorName,
            status: statusFilter,
            // status: type === 'requestor'
                // ? (selectedStatuses.length === 0 ? [0, 2, 3] : selectedStatuses)
                // : (selectedStatuses.length === 0 ? [1, 5, 6, 7, 8, 9] : selectedStatuses), 
                // ? (selectedStatuses.length === 0 ? [0, 1, 2, 4] : selectedStatuses)

                // ? (selectedStatuses.length === 0 ? [] : selectedStatuses)
                // : (selectedStatuses.length === 0 ? [1, 4, 5, 6, 7, 8] : selectedStatuses),


            job: jobName,
            samples: selectedSamples,
            from_date: selectedDateRange[0],
            to_date: selectedDateRange[1],
            project_name: projectName,
            lab_status: selectedLabStatuses,
            // lab_status: type === 'requestor' ? ( selectedLabStatuses.length ===0 ? [1,2,3,4] : selectedLabStatuses) : [],
            lab_name: null
        };

        const params = {
            limit: pagination.limit,
            offset: pagination.offset,
            filters: [filters],
            range: selectedRange,
            user_id: type == 'requestor' ? userId : null,
            // user_id: null,
            // sort: [{ donation: donationSortDirection }],
            // sort: [{ total_donations: donationSortDirection }],
        };

        SampleRequestService.getSampleRequestList(params)
            .then((response) => {
                setSampleRequestList(response.data.list);
                setTotalSampleRequest(response.data.total_request)
                setLoading(false); 
            })
            .catch((error) => {
                console.error("Failed to fetch sample request list", error);
                setLoading(false);
            });

         


    }
       
    function fetchLabStatuses() {
        getLabStatuses()
            .then((labStatusTypes) => {
                setLabStatuses(labStatusTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch lab status types", error);
            });
    }
    function fetchStatuses() {
        getStatuses()
            .then((statusTypes) => {
                setStatuses(statusTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch status types", error);
            });
    }
    async function fetchSampleTypes() {
        AdminService.getSampleTypes()
            .then((sampleTypes) => {
                setSamples(sampleTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch sample types", error);
            });
    }
    function fetchGenders() {
        AdminService.getAdminListGenderTypes()
            .then((genderTypes) => {
                setGenders(genderTypes);
            })
            .catch((error) => {
                console.error("Failed to fetch gender types", error);
            });
    }

    const handleStatusChange = (status) => {
        if (selectedStatuses.includes(status)) {
            setSelectedStatuses(selectedStatuses.filter((s) => s !== status));
        } else {


            setSelectedStatuses([...selectedStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };

    const handleLabStatusChange = (status) => {
        if (selectedLabStatuses.includes(status)) {
            setSelectedLabStatuses(selectedLabStatuses.filter((s) => s !== status));
        } else {


            setSelectedLabStatuses([...selectedLabStatuses, status]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
    const handleGenderChange = (gender) => {
        if (selectedGenders.includes(gender)) {
            setSelectedGenders(selectedGenders.filter((g) => g !== gender));
        } else {
            setSelectedGenders([...selectedGenders, gender]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };
    const handleSampleChange = (sample) => {
        if (selectedSamples.includes(sample)) {
            setSelectedSamples(selectedSamples.filter((s) => s !== sample));
        } else {
            setSelectedSamples([...selectedSamples, sample]);
        }
        setPagination({ ...pagination, page: 1, offset: 0 });
    };


    const handleDateRangeChange = (daterange) => {

        if (daterange[0] && daterange[1]) {
            const startDate = dayjs(daterange[0]).startOf('day').toDate();
            const endDate = dayjs(daterange[1]).endOf('day').toDate();
            const dateRangee = [startDate, endDate];
            
            // Set the selected date range to the adjusted date array
            setSelectedDateRange(dateRangee);

            // Reset pagination whenever the date range changes
            setPagination({ ...pagination, page: 1, offset: 0 });
        }
        else{
            setSelectedDateRange([null,null]);
        }

    };

    const handleCancelRequest = async (sample, cancellationNote) => {
     

        setLoading(true);
        const payload = {
            request_id : sample.id,
            cancel_note: cancellationNote,
        }
        try {
            const response = await SampleRequestService.cancelSampleRequest(payload);
            
            
            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                fetchSampleTypeList();
                setLoading(false);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {
            setToastMessage("Failed to cancel sample request");
            setShowToast(true);
            setToastVariant('error');
            console.error("Failed to cancel sample request:", error);
            setLoading(false);
        }
    };

    const handleDeleteRequest = async (userId) => {
        setLoading(true);
        try {
            const response = await SampleRequestService.deleteSampleRequest(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Sample request draft deleted successfully:", response);
                fetchSampleTypeList();
                setLoading(false);
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
                setLoading(false);
            }
        } catch (error) {
            console.error("Failed to delete request draft:", error);
            setToastMessage(error.response.data.message);
            setShowToast(true);
            setToastVariant('error');
            setLoading(false);
        }
    };

    const handlePickupDetailsUpdateModal = async (requestId, values) => {
        try { 
            const payload = {
                request_id : requestId,
                pickup_date : values.pickupDate, 
                pickup_time: values.pickupTime, 
                pickup_by: values.pickedUpBy
            }
        
            const response = await SampleRequestService.updatePickupDetails(payload);
    
            if (response.success) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Sample request pickup details updated successfully:", response);
                fetchSampleTypeList();
            } else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to update sample request pickup details:", error);
        }
    };
    const handleDuplicateRequest = async (userId) => {
        try {
            const response = await SampleRequestService.duplicateSampleRequest(userId);

            if (response.success == true) {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('success');
                console.log("Sample request duplication successfully:", response);

                 // Use response.request_id to navigate
                const { duplicate_id } = response;
                // const  request_id  = userId;
                navigate(`/requestor/request-new-sample`, { state: { id: duplicate_id } });

                // fetchSampleTypeList();
            }
            else {
                setToastMessage(response.message);
                setShowToast(true);
                setToastVariant('error');
            }
        } catch (error) {
            console.error("Failed to duplicate sample request:", error);
            setToastMessage(error.message);
            setShowToast(true);
            setToastVariant('error');
        }
    };

    const handleRowsPerPageChange = (newRowsPerPage) => {

        if (newRowsPerPage === 'Show All') {
            setRowsPerPage(totalSampleRequest);
            setPagination({ limit: totalSampleRequest, offset: 0, page: 1 });
        } else {
            setRowsPerPage(Number(newRowsPerPage));
            setPagination({ limit: Number(newRowsPerPage), offset: 0, page: 1 });
        }
    };

    const totalFiltered = SampleTypeList.length;  //ex 10 
    const totalPages = Math.ceil(totalSampleRequest / rowsPerPage); // 10 / 2rpp  then  5 pages

    const handleNextPage = () => {
        setPagination({ ...pagination, offset: pagination.page * rowsPerPage, page: pagination.page + 1 });
    };

    const handlePreviousPage = () => {
        setPagination({ ...pagination, offset: (pagination.page - 2) * rowsPerPage, page: pagination.page - 1 });
    };
    const isMobile = useMediaQuery({ maxWidth: 768 });
    return (
        <div className="">
            <Loader loading={loading}/>

            {isMobile ? (
           <div className="admin-card-list mt-3">
            {SampleTypeList.length > 0 ? (
                                
                                <div  className="row"> 
              {
              SampleTypeList.map((SampleType, index) => (
                <div className="col-sm-12 col-md-6 mb-3" key={SampleType.id}>
                                <SampleTypeTableRow
                                    key={index}
                                    sampleType={SampleType}
                                    handleCancelRequest={handleCancelRequest}
                                    handleDeleteRequest={handleDeleteRequest}
                                    handleDuplicateRequest={handleDuplicateRequest}
                                    handlePickupDetailsUpdateModal={handlePickupDetailsUpdateModal}
                                    fetchSampleTypeList={fetchSampleTypeList}
                                    sampleTypes={samples}
                                    type={type}
                                />
                                </div>
                            )) } </div>) : (
                                <NoListDataAvailable type="sample requests" />
                            )}
         </div>
         ):(<>

            <div className="el-table-container el-board-table table-x-scroll ">
                <Table hover className="table table-striped">
                     {/* el-table-fixed */}
                    <thead>
                        <tr>
                            {/* Lab status */}
                            {/* //lab status removed */}
                            {/* {type === 'requestor' && (
                                <th>
                                    <AdminStatusDropdown
                                        statuses={labStatuses}
                                        selectedStatuses={selectedLabStatuses}
                                        handleStatusChange={handleLabStatusChange}
                                        setSelectedStatuses={setSelectedLabStatuses}
                                        label="Lab Status"
                                    />
                                </th>
                            )} */}

                            {/*   status */}
                            <th>
                                <AdminStatusDropdown
                                    statuses={statuses}
                                    selectedStatuses={selectedStatuses}
                                    handleStatusChange={handleStatusChange}
                                    setSelectedStatuses={setSelectedStatuses}
                                    label="Status"
                                    type={type}
                                />
                            </th>
                            <th>
                                {/* Job search */}
                                <SearchInput
                                    label="Job #"
                                    value={jobName}
                                    setValue={setJobName}
                                    isVisible={isJobNameVisible}
                                    setVisible={setJobNameInputVisible}
                                />
                            </th>
                            {/* <th>
                                <BiologicalSexDropdown
                                    genders={genders}
                                    selectedGenders={selectedGenders}
                                    handleGenderChange={handleGenderChange}
                                    setSelectedGenders={setSelectedGenders} />
                            </th> */}
                            <th>
                                <SampleTypeDropdown
                                    samples={samples}
                                    selectedSamples={selectedSamples}
                                    handleSampleChange={handleSampleChange}
                                    setSelectedSamples={setSelectedSamples} />
                            </th>
                            {/* Due date */}
                            {/* <th>
                                <label>Due date</label>
                                
                            </th> */}
                            <th>
                                <DateRangeFilter
                                    selectedDateRange={selectedDateRange}
                                    handleDateRangeChange={handleDateRangeChange}
                                    setSelectedDateRange={setSelectedDateRange}
                                    label={type == 'requestor' ? "Collection Date" : "Due Date"} />
                            </th>

                            {type != 'requestor' && (<th>
                                {/* Requestor search */}
                                <SearchInput
                                    label="Requestor"
                                    value={requestorName}
                                    setValue={setRequestorName}
                                    isVisible={isRequestorNameVisible}
                                    setVisible={setRequestorNameInputVisible}
                                />
                            </th>)}

                            <th>
                                {/* Project search */}
                                <SearchInput
                                    label="Project Name"
                                    value={projectName}
                                    setValue={setProjectName}
                                    isVisible={isProjectNameVisible}
                                    setVisible={setProjectNameInputVisible}
                                />
                            </th>
                            <th>
                                <label>   {type == 'requestor' ? '# Of Volunteers' : 'Donors'}</label>
                            </th>
                            <th>Actions</th>
                        </tr>
                    </thead>
                    <tbody>
                        {SampleTypeList.length > 0 ? (SampleTypeList.map((SampleType, index) => (
                                <SampleTypeTableRow
                                    key={SampleType.id}
                                    sampleType={SampleType}
                                    handleCancelRequest={handleCancelRequest}
                                    handleDeleteRequest={handleDeleteRequest}
                                    handleDuplicateRequest={handleDuplicateRequest}
                                    handlePickupDetailsUpdateModal={handlePickupDetailsUpdateModal}
                                    fetchSampleTypeList={fetchSampleTypeList}
                                    sampleTypes={samples}
                                    type={type}
                                />
                            ))) : (
                                <NoListDataAvailable type="sample requests" />
                            )}
                    </tbody>
                </Table>
            </div>

            </>
        )}
            <TablePagination
                rowsPerPage={rowsPerPage}
                handleRowsPerPageChange={handleRowsPerPageChange}
                pagination={pagination}
                totalPages={totalPages}
                handlePreviousPage={handlePreviousPage}
                handleNextPage={handleNextPage}
                totalUsers={totalSampleRequest}
            />
            <Toaster
                show={showToast}
                message={toastMessage}
                variant={toastVariant}
                onClose={() => setShowToast(false)}
            />
        </div>
    );
}
export default SampleRequestListTable;
